module.exports = __webpack_public_path__ + "static/media/laundry_bag.2586985c.svg";